import { Close } from '@mui/icons-material';
import {
    Box,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Modal,
    Typography,
    Divider,
} from '@mui/material';
import React from 'react';

export const ClusterSiteListModal = ({ open, onClose, clusterSiteList, onSiteClick }) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                className="user-modal-responsive"
            >
                {/* Header */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: 2,
                        py: 1.5,
                        borderBottom: '1px solid #e0e0e0',
                        // bgcolor: '#f5f5f5',
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Site List
                    </Typography>
                    <IconButton onClick={onClose} size="small">
                        <Close fontSize="small" />
                    </IconButton>
                </Box>

                {/* List */}
                <Box sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    <List dense disablePadding>
                        {clusterSiteList?.length > 0 ? (
                            clusterSiteList.map((site, index) => (
                                <React.Fragment key={index}>
                                    <ListItem
                                        sx={{
                                            cursor: 'pointer',
                                            px: 2,
                                            py: 1.2,
                                            '&:hover': {
                                                bgcolor: '#f0f0f0',
                                            },
                                        }}
                                        onClick={() => { onClose(); onSiteClick(site) }}
                                    >
                                        <ListItemText
                                            primary={
                                                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                    {site?.name}
                                                </Typography>
                                            }
                                        />
                                    </ListItem>
                                    {index !== clusterSiteList.length - 1 && <Divider />}
                                </React.Fragment>
                            ))
                        ) : (
                            <ListItem sx={{ px: 2, py: 2 }}>
                                <ListItemText
                                    primary={
                                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                                            No sites available.
                                        </Typography>
                                    }
                                />
                            </ListItem>
                        )}
                    </List>
                </Box>
            </Box>
        </Modal>
    );
};
